import { render, staticRenderFns } from "./PackageExtendCreateDialog.vue?vue&type=template&id=71aa51c8&scoped=true"
import script from "./PackageExtendCreateDialog.vue?vue&type=script&lang=js"
export * from "./PackageExtendCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageExtendCreateDialog.vue?vue&type=style&index=0&id=71aa51c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aa51c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71aa51c8')) {
      api.createRecord('71aa51c8', component.options)
    } else {
      api.reload('71aa51c8', component.options)
    }
    module.hot.accept("./PackageExtendCreateDialog.vue?vue&type=template&id=71aa51c8&scoped=true", function () {
      api.rerender('71aa51c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageExtendCreateDialog.vue"
export default component.exports